// 导入
import Vue from 'vue'
import Vuex from 'vuex'

// 安装使用
Vue.use(Vuex);
// 第一种方式导出
export default new Vuex.Store({
  state: {
  	meituan: '',
  	demo:false
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})


// WEBPACK FOOTER //
// ./src/store/index.js